//https://github.com/tommoor/react-emoji-render/blob/master/data/aliases.js
module.exports = {
  "skin-tone-2": "🏻",
  "skin-tone-3": "🏿",
  "skin-tone-4": "🏽",
  "skin-tone-5": "🏾",
  "skin-tone-6": "🏿",
  "100": "💯",
  "1234": "🔢",
  money_mouth_face: "🤑",
  skull_and_crossbones: "☠️",
  smile: "😄",
  smiley: "😃",
  grinning: "😀",
  ':)' : "🙂",
  slightly_smiling_face: "🙂",
  blush: "😊",
  relaxed: "☺️",
  wink: "😉",
  heart_eyes: "😍",
  kissing_heart: "😘",
  kissing_closed_eyes: "😚",
  kissing: "😗",
  kissing_smiling_eyes: "😙",
  stuck_out_tongue_winking_eye: "😜",
  stuck_out_tongue_closed_eyes: "😝",
  stuck_out_tongue: "😛",
  flushed: "😳",
  grin: "😁",
  pensive: "😔",
  relieved: "😌",
  unamused: "😒",
  disappointed: "😞",
  persevere: "😣",
  cry: "😢",
  joy: "😂",
  sob: "😭",
  sleepy: "😪",
  disappointed_relieved: "😥",
  cold_sweat: "😰",
  sweat_smile: "😅",
  sweat: "😓",
  weary: "😩",
  tired_face: "😫",
  fearful: "😨",
  scream: "😱",
  angry: "😠",
  rage: "😡",
  pout: "😡",
  triumph: "😤",
  confounded: "😖",
  laughing: "😆",
  satisfied: "😆",
  yum: "😋",
  mask: "😷",
  sunglasses: "😎",
  sleeping: "😴",
  dizzy_face: "😵",
  astonished: "😲",
  worried: "😟",
  frowning: "😦",
  anguished: "😧",
  smiling_imp: "😈",
  imp: "👿",
  open_mouth: "😮",
  grimacing: "😬",
  neutral_face: "😐",
  confused: "😕",
  hushed: "😯",
  no_mouth: "😶",
  innocent: "😇",
  smirk: "😏",
  expressionless: "😑",
  man_with_gua_pi_mao: "👲",
  man_with_turban: "👳",
  cop: "👮",
  construction_worker: "👷",
  guardsman: "💂",
  baby: "👶",
  boy: "👦",
  girl: "👧",
  man: "👨",
  woman: "👩",
  older_man: "👴",
  older_woman: "👵",
  person_with_blond_hair: "👱",
  angel: "👼",
  princess: "👸",
  smiley_cat: "😺",
  smile_cat: "😸",
  heart_eyes_cat: "😻",
  kissing_cat: "😽",
  smirk_cat: "😼",
  scream_cat: "🙀",
  crying_cat_face: "😿",
  joy_cat: "😹",
  pouting_cat: "😾",
  japanese_ogre: "👹",
  japanese_goblin: "👺",
  see_no_evil: "🙈",
  hear_no_evil: "🙉",
  speak_no_evil: "🙊",
  skull: "💀",
  alien: "👽",
  hankey: "💩",
  poop: "💩",
  shit: "💩",
  fire: "🔥",
  sparkles: "✨",
  star2: "🌟",
  dizzy: "💫",
  boom: "💥",
  collision: "💥",
  anger: "💢",
  sweat_drops: "💦",
  droplet: "💧",
  zzz: "💤",
  dash: "💨",
  ear: "👂",
  eyes: "👀",
  nose: "👃",
  tongue: "👅",
  lips: "👄",
  "+1": "👍",
  thumbsup: "👍",
  "-1": "👎",
  thumbsdown: "👎",
  ok_hand: "👌",
  facepunch: "👊",
  punch: "👊",
  fist: "✊",
  v: "✌️",
  wave: "👋",
  hand: "✋",
  raised_hand: "✋",
  open_hands: "👐",
  point_up_2: "👆",
  point_down: "👇",
  point_right: "👉",
  point_left: "👈",
  raised_hands: "🙌",
  pray: "🙏",
  point_up: "☝️",
  clap: "👏",
  muscle: "💪",
  walking: "🚶",
  runner: "🏃",
  running: "🏃",
  dancer: "💃",
  couple: "👫",
  family: "👪",
  two_men_holding_hands: "👬",
  two_women_holding_hands: "👭",
  couplekiss: "💏",
  couple_with_heart: "💑",
  dancers: "👯",
  ok_woman: "🙆",
  no_good: "🙅",
  ng_woman: "🙅",
  information_desk_person: "💁",
  raising_hand: "🙋",
  massage: "💆",
  haircut: "💇",
  nail_care: "💅",
  bride_with_veil: "👰",
  person_with_pouting_face: "🙎",
  person_frowning: "🙍",
  bow: "🙇",
  tophat: "🎩",
  crown: "👑",
  womans_hat: "👒",
  athletic_shoe: "👟",
  mans_shoe: "👞",
  shoe: "👞",
  sandal: "👡",
  high_heel: "👠",
  boot: "👢",
  shirt: "👕",
  tshirt: "👕",
  necktie: "👔",
  womans_clothes: "👚",
  dress: "👗",
  running_shirt_with_sash: "🎽",
  jeans: "👖",
  kimono: "👘",
  bikini: "👙",
  briefcase: "💼",
  handbag: "👜",
  pouch: "👝",
  purse: "👛",
  eyeglasses: "👓",
  ribbon: "🎀",
  closed_umbrella: "🌂",
  lipstick: "💄",
  yellow_heart: "💛",
  blue_heart: "💙",
  purple_heart: "💜",
  green_heart: "💚",
  heart: "❤️",
  broken_heart: "💔",
  heartpulse: "💗",
  heartbeat: "💓",
  two_hearts: "💕",
  sparkling_heart: "💖",
  revolving_hearts: "💞",
  cupid: "💘",
  love_letter: "💌",
  kiss: "💋",
  ring: "💍",
  gem: "💎",
  bust_in_silhouette: "👤",
  busts_in_silhouette: "👥",
  speech_balloon: "💬",
  footprints: "👣",
  thought_balloon: "💭",
  dog: "🐶",
  wolf: "🐺",
  cat: "🐱",
  mouse: "🐭",
  hamster: "🐹",
  rabbit: "🐰",
  frog: "🐸",
  tiger: "🐯",
  koala: "🐨",
  bear: "🐻",
  pig: "🐷",
  pig_nose: "🐽",
  cow: "🐮",
  boar: "🐗",
  monkey_face: "🐵",
  monkey: "🐒",
  horse: "🐴",
  sheep: "🐑",
  elephant: "🐘",
  panda_face: "🐼",
  penguin: "🐧",
  bird: "🐦",
  baby_chick: "🐤",
  hatched_chick: "🐥",
  hatching_chick: "🐣",
  chicken: "🐔",
  snake: "🐍",
  turtle: "🐢",
  bug: "🐛",
  bee: "🐝",
  honeybee: "🐝",
  ant: "🐜",
  beetle: "🐞",
  snail: "🐌",
  octopus: "🐙",
  shell: "🐚",
  tropical_fish: "🐠",
  fish: "🐟",
  dolphin: "🐬",
  flipper: "🐬",
  whale: "🐳",
  whale2: "🐋",
  cow2: "🐄",
  ram: "🐏",
  rat: "🐀",
  water_buffalo: "🐃",
  tiger2: "🐅",
  rabbit2: "🐇",
  dragon: "🐉",
  racehorse: "🐎",
  goat: "🐐",
  rooster: "🐓",
  dog2: "🐕",
  pig2: "🐖",
  mouse2: "🐁",
  ox: "🐂",
  dragon_face: "🐲",
  blowfish: "🐡",
  crocodile: "🐊",
  camel: "🐫",
  dromedary_camel: "🐪",
  leopard: "🐆",
  cat2: "🐈",
  poodle: "🐩",
  feet: "🐾",
  paw_prints: "🐾",
  bouquet: "💐",
  cherry_blossom: "🌸",
  tulip: "🌷",
  four_leaf_clover: "🍀",
  rose: "🌹",
  sunflower: "🌻",
  hibiscus: "🌺",
  maple_leaf: "🍁",
  leaves: "🍃",
  fallen_leaf: "🍂",
  herb: "🌿",
  ear_of_rice: "🌾",
  mushroom: "🍄",
  cactus: "🌵",
  palm_tree: "🌴",
  evergreen_tree: "🌲",
  deciduous_tree: "🌳",
  chestnut: "🌰",
  seedling: "🌱",
  blossom: "🌼",
  globe_with_meridians: "🌐",
  sun_with_face: "🌞",
  full_moon_with_face: "🌝",
  new_moon_with_face: "🌚",
  new_moon: "🌑",
  waxing_crescent_moon: "🌒",
  first_quarter_moon: "🌓",
  moon: "🌔",
  waxing_gibbous_moon: "🌔",
  full_moon: "🌕",
  waning_gibbous_moon: "🌖",
  last_quarter_moon: "🌗",
  waning_crescent_moon: "🌘",
  last_quarter_moon_with_face: "🌜",
  first_quarter_moon_with_face: "🌛",
  crescent_moon: "🌙",
  earth_africa: "🌍",
  earth_americas: "🌎",
  earth_asia: "🌏",
  volcano: "🌋",
  milky_way: "🌌",
  stars: "🌠",
  star: "⭐",
  sunny: "☀️",
  partly_sunny: "⛅",
  cloud: "☁️",
  zap: "⚡",
  umbrella: "☔",
  snowflake: "❄️",
  snowman: "⛄",
  cyclone: "🌀",
  foggy: "🌁",
  rainbow: "🌈",
  ocean: "🌊",
  bamboo: "🎍",
  gift_heart: "💝",
  dolls: "🎎",
  school_satchel: "🎒",
  mortar_board: "🎓",
  flags: "🎏",
  fireworks: "🎆",
  sparkler: "🎇",
  wind_chime: "🎐",
  rice_scene: "🎑",
  jack_o_lantern: "🎃",
  ghost: "👻",
  santa: "🎅",
  christmas_tree: "🎄",
  gift: "🎁",
  tanabata_tree: "🎋",
  tada: "🎉",
  confetti_ball: "🎊",
  balloon: "🎈",
  crossed_flags: "🎌",
  crystal_ball: "🔮",
  movie_camera: "🎥",
  camera: "📷",
  video_camera: "📹",
  vhs: "📼",
  cd: "💿",
  dvd: "📀",
  minidisc: "💽",
  floppy_disk: "💾",
  desktop_computer: "🖥️",
  computer: "💻",
  iphone: "📱",
  phone: "☎️",
  telephone: "☎️",
  telephone_receiver: "📞",
  pager: "📟",
  fax: "📠",
  satellite: "📡",
  tv: "📺",
  radio: "📻",
  loud_sound: "🔊",
  sound: "🔉",
  speaker: "🔈",
  mute: "🔇",
  bell: "🔔",
  no_bell: "🔕",
  loudspeaker: "📢",
  mega: "📣",
  hourglass_flowing_sand: "⏳",
  hourglass: "⌛",
  alarm_clock: "⏰",
  watch: "⌚",
  unlock: "🔓",
  lock: "🔒",
  lock_with_ink_pen: "🔏",
  closed_lock_with_key: "🔐",
  key: "🔑",
  mag_right: "🔎",
  bulb: "💡",
  flashlight: "🔦",
  high_brightness: "🔆",
  low_brightness: "🔅",
  electric_plug: "🔌",
  battery: "🔋",
  mag: "🔍",
  bathtub: "🛁",
  bath: "🛀",
  shower: "🚿",
  toilet: "🚽",
  wrench: "🔧",
  nut_and_bolt: "🔩",
  hammer: "🔨",
  hammer_and_pick: "⚒",
  hammer_and_wrench: "⚒",
  door: "🚪",
  smoking: "🚬",
  bomb: "💣",
  gun: "🔫",
  hocho: "🔪",
  knife: "🔪",
  pill: "💊",
  syringe: "💉",
  moneybag: "💰",
  yen: "💴",
  dollar: "💵",
  pound: "💷",
  euro: "💶",
  credit_card: "💳",
  money_with_wings: "💸",
  calling: "📲",
  "e-mail": "📧",
  inbox_tray: "📥",
  outbox_tray: "📤",
  email: "✉️",
  envelope: "✉️",
  envelope_with_arrow: "📩",
  incoming_envelope: "📨",
  postal_horn: "📯",
  mailbox: "📫",
  mailbox_closed: "📪",
  mailbox_with_mail: "📬",
  mailbox_with_no_mail: "📭",
  postbox: "📮",
  package: "📦",
  memo: "📝",
  pencil: "📝",
  page_facing_up: "📄",
  page_with_curl: "📃",
  bookmark_tabs: "📑",
  bar_chart: "📊",
  chart_with_upwards_trend: "📈",
  chart_with_downwards_trend: "📉",
  scroll: "📜",
  clipboard: "📋",
  date: "📅",
  calendar: "📆",
  card_index: "📇",
  file_folder: "📁",
  open_file_folder: "📂",
  scissors: "✂️",
  pushpin: "📌",
  paperclip: "📎",
  black_nib: "✒️",
  pencil2: "✏️",
  straight_ruler: "📏",
  triangular_ruler: "📐",
  closed_book: "📕",
  green_book: "📗",
  blue_book: "📘",
  orange_book: "📙",
  notebook: "📓",
  notebook_with_decorative_cover: "📔",
  ledger: "📒",
  books: "📚",
  book: "📖",
  open_book: "📖",
  bookmark: "🔖",
  name_badge: "📛",
  microscope: "🔬",
  telescope: "🔭",
  newspaper: "📰",
  art: "🎨",
  clapper: "🎬",
  microphone: "🎤",
  headphones: "🎧",
  musical_score: "🎼",
  musical_note: "🎵",
  notes: "🎶",
  musical_keyboard: "🎹",
  violin: "🎻",
  trumpet: "🎺",
  saxophone: "🎷",
  guitar: "🎸",
  space_invader: "👾",
  video_game: "🎮",
  black_joker: "🃏",
  flower_playing_cards: "🎴",
  mahjong: "🀄",
  game_die: "🎲",
  dart: "🎯",
  football: "🏈",
  basketball: "🏀",
  soccer: "⚽",
  baseball: "⚾️",
  tennis: "🎾",
  "8ball": "🎱",
  rugby_football: "🏉",
  bowling: "🎳",
  golf: "⛳",
  mountain_bicyclist: "🚵",
  bicyclist: "🚴",
  checkered_flag: "🏁",
  horse_racing: "🏇",
  trophy: "🏆",
  ski: "🎿",
  snowboarder: "🏂",
  swimmer: "🏊",
  surfer: "🏄",
  fishing_pole_and_fish: "🎣",
  coffee: "☕",
  tea: "🍵",
  sake: "🍶",
  baby_bottle: "🍼",
  beer: "🍺",
  beers: "🍻",
  cocktail: "🍸",
  tropical_drink: "🍹",
  wine_glass: "🍷",
  fork_and_knife: "🍴",
  pizza: "🍕",
  hamburger: "🍔",
  fries: "🍟",
  poultry_leg: "🍗",
  meat_on_bone: "🍖",
  spaghetti: "🍝",
  curry: "🍛",
  fried_shrimp: "🍤",
  bento: "🍱",
  sushi: "🍣",
  fish_cake: "🍥",
  rice_ball: "🍙",
  rice_cracker: "🍘",
  rice: "🍚",
  ramen: "🍜",
  stew: "🍲",
  oden: "🍢",
  dango: "🍡",
  egg: "🍳",
  bread: "🍞",
  doughnut: "🍩",
  custard: "🍮",
  icecream: "🍦",
  ice_cream: "🍨",
  shaved_ice: "🍧",
  birthday: "🎂",
  cake: "🍰",
  cookie: "🍪",
  chocolate_bar: "🍫",
  candy: "🍬",
  lollipop: "🍭",
  honey_pot: "🍯",
  apple: "🍎",
  green_apple: "🍏",
  tangerine: "🍊",
  orange: "🍊",
  mandarin: "🍊",
  lemon: "🍋",
  cherries: "🍒",
  grapes: "🍇",
  watermelon: "🍉",
  strawberry: "🍓",
  peach: "🍑",
  melon: "🍈",
  banana: "🍌",
  pear: "🍐",
  pineapple: "🍍",
  sweet_potato: "🍠",
  eggplant: "🍆",
  tomato: "🍅",
  corn: "🌽",
  house: "🏠",
  house_with_garden: "🏡",
  school: "🏫",
  office: "🏢",
  post_office: "🏣",
  hospital: "🏥",
  bank: "🏦",
  convenience_store: "🏪",
  love_hotel: "🏩",
  hotel: "🏨",
  wedding: "💒",
  church: "⛪",
  department_store: "🏬",
  european_post_office: "🏤",
  city_sunrise: "🌇",
  city_sunset: "🌆",
  japanese_castle: "🏯",
  european_castle: "🏰",
  tent: "⛺",
  factory: "🏭",
  tokyo_tower: "🗼",
  japan: "🗾",
  mount_fuji: "🗻",
  sunrise_over_mountains: "🌄",
  sunrise: "🌅",
  night_with_stars: "🌃",
  statue_of_liberty: "🗽",
  bridge_at_night: "🌉",
  carousel_horse: "🎠",
  ferris_wheel: "🎡",
  fountain: "⛲",
  roller_coaster: "🎢",
  ship: "🚢",
  boat: "⛵",
  sailboat: "⛵",
  speedboat: "🚤",
  rowboat: "🚣",
  anchor: "⚓",
  rocket: "🚀",
  airplane: "✈️",
  seat: "💺",
  helicopter: "🚁",
  steam_locomotive: "🚂",
  tram: "🚊",
  station: "🚉",
  mountain_railway: "🚞",
  train2: "🚆",
  bullettrain_side: "🚄",
  bullettrain_front: "🚅",
  light_rail: "🚈",
  metro: "🚇",
  monorail: "🚝",
  train: "🚋",
  railway_car: "🚃",
  trolleybus: "🚎",
  bus: "🚌",
  oncoming_bus: "🚍",
  blue_car: "🚙",
  oncoming_automobile: "🚘",
  car: "🚗",
  red_car: "🚗",
  taxi: "🚕",
  oncoming_taxi: "🚖",
  articulated_lorry: "🚛",
  truck: "🚚",
  rotating_light: "🚨",
  police_car: "🚓",
  oncoming_police_car: "🚔",
  fire_engine: "🚒",
  ambulance: "🚑",
  minibus: "🚐",
  bike: "🚲",
  aerial_tramway: "🚡",
  suspension_railway: "🚟",
  mountain_cableway: "🚠",
  tractor: "🚜",
  barber: "💈",
  busstop: "🚏",
  ticket: "🎫",
  vertical_traffic_light: "🚦",
  traffic_light: "🚥",
  warning: "⚠️",
  construction: "🚧",
  beginner: "🔰",
  fuelpump: "⛽",
  izakaya_lantern: "🏮",
  lantern: "🏮",
  slot_machine: "🎰",
  hotsprings: "♨️",
  moyai: "🗿",
  circus_tent: "🎪",
  performing_arts: "🎭",
  round_pushpin: "📍",
  triangular_flag_on_post: "🚩",
  jp: "🇯🇵",
  kr: "🇰🇷",
  de: "🇩🇪",
  cn: "🇨🇳",
  us: "🇺🇸",
  fr: "🇫🇷",
  es: "🇪🇸",
  it: "🇮🇹",
  ru: "🇷🇺",
  gb: "🇬🇧",
  uk: "🇬🇧",
  one: "1️⃣",
  two: "2️⃣",
  three: "3️⃣",
  four: "4️⃣",
  five: "5️⃣",
  six: "6️⃣",
  seven: "7️⃣",
  eight: "8️⃣",
  nine: "9️⃣",
  zero: "0️⃣",
  keycap_ten: "🔟",
  hash: "#️⃣",
  symbols: "🔣",
  arrow_up: "⬆️",
  arrow_down: "⬇️",
  arrow_left: "⬅️",
  arrow_right: "➡️",
  capital_abcd: "🔠",
  abcd: "🔡",
  abc: "🔤",
  arrow_upper_right: "↗️",
  arrow_upper_left: "↖️",
  arrow_lower_right: "↘️",
  arrow_lower_left: "↙️",
  left_right_arrow: "↔️",
  arrow_up_down: "↕️",
  arrows_counterclockwise: "🔄",
  arrow_backward: "◀️",
  arrow_forward: "▶️",
  arrow_up_small: "🔼",
  arrow_down_small: "🔽",
  leftwards_arrow_with_hook: "↩️",
  arrow_right_hook: "↪️",
  information_source: "ℹ️",
  rewind: "⏪",
  fast_forward: "⏩",
  arrow_double_up: "⏫",
  arrow_double_down: "⏬",
  arrow_heading_down: "⤵️",
  arrow_heading_up: "⤴️",
  ok: "🆗",
  twisted_rightwards_arrows: "🔀",
  repeat: "🔁",
  repeat_one: "🔂",
  new: "🆕",
  up: "🆙",
  cool: "🆒",
  free: "🆓",
  ng: "🆖",
  signal_strength: "📶",
  cinema: "🎦",
  koko: "🈁",
  u6307: "🈯",
  u7a7a: "🈳",
  u6e80: "🈵",
  u5408: "🈴",
  u7981: "🈲",
  ideograph_advantage: "🉐",
  u5272: "🈹",
  u55b6: "🈺",
  u6709: "🈶",
  u7121: "🈚",
  restroom: "🚻",
  mens: "🚹",
  womens: "🚺",
  baby_symbol: "🚼",
  wc: "🚾",
  potable_water: "🚰",
  put_litter_in_its_place: "🚮",
  parking: "🅿️",
  wheelchair: "♿",
  no_smoking: "🚭",
  u6708: "🈷️",
  u7533: "🈸",
  sa: "🈂️",
  m: "Ⓜ️",
  passport_control: "🛂",
  baggage_claim: "🛄",
  left_luggage: "🛅",
  customs: "🛃",
  accept: "🉑",
  secret: "㊙️",
  congratulations: "㊗️",
  cl: "🆑",
  sos: "🆘",
  id: "🆔",
  no_entry_sign: "🚫",
  underage: "🔞",
  no_mobile_phones: "📵",
  do_not_litter: "🚯",
  "non-potable_water": "🚱",
  no_bicycles: "🚳",
  no_pedestrians: "🚷",
  children_crossing: "🚸",
  no_entry: "⛔",
  eight_spoked_asterisk: "✳️",
  sparkle: "❇️",
  negative_squared_cross_mark: "❎",
  white_check_mark: "✅",
  eight_pointed_black_star: "✴️",
  heart_decoration: "💟",
  vs: "🆚",
  vibration_mode: "📳",
  mobile_phone_off: "📴",
  a: "🅰️",
  b: "🅱️",
  ab: "🆎",
  o2: "🅾️",
  diamond_shape_with_a_dot_inside: "💠",
  loop: "➿",
  recycle: "♻️",
  aries: "♈",
  taurus: "♉",
  gemini: "♊",
  cancer: "♋",
  leo: "♌",
  virgo: "♍",
  libra: "♎",
  scorpius: "♏",
  sagittarius: "♐",
  capricorn: "♑",
  aquarius: "♒",
  pisces: "♓",
  ophiuchus: "⛎",
  six_pointed_star: "🔯",
  atm: "🏧",
  chart: "💹",
  heavy_dollar_sign: "💲",
  currency_exchange: "💱",
  copyright: "©️",
  registered: "®️",
  tm: "™️",
  x: "❌",
  bangbang: "‼️",
  interrobang: "⁉️",
  exclamation: "❗",
  heavy_exclamation_mark: "❗",
  question: "❓",
  grey_exclamation: "❕",
  grey_question: "❔",
  o: "⭕",
  top: "🔝",
  end: "🔚",
  back: "🔙",
  on: "🔛",
  soon: "🔜",
  arrows_clockwise: "🔃",
  clock12: "🕛",
  clock1230: "🕧",
  clock1: "🕐",
  clock130: "🕜",
  clock2: "🕑",
  clock230: "🕝",
  clock3: "🕒",
  clock330: "🕞",
  clock4: "🕓",
  clock430: "🕟",
  clock5: "🕔",
  clock530: "🕠",
  clock6: "🕕",
  clock7: "🕖",
  clock8: "🕗",
  clock9: "🕘",
  clock10: "🕙",
  clock11: "🕚",
  clock630: "🕡",
  clock730: "🕢",
  clock830: "🕣",
  clock930: "🕤",
  clock1030: "🕥",
  clock1130: "🕦",
  heavy_multiplication_x: "✖️",
  heavy_plus_sign: "➕",
  heavy_minus_sign: "➖",
  heavy_division_sign: "➗",
  spades: "♠️",
  hearts: "♥️",
  clubs: "♣️",
  diamonds: "♦️",
  white_flower: "💮",
  heavy_check_mark: "✔️",
  ballot_box_with_check: "☑️",
  radio_button: "🔘",
  link: "🔗",
  curly_loop: "➰",
  wavy_dash: "〰️",
  part_alternation_mark: "〽️",
  trident: "🔱",
  black_medium_square: "◼️",
  white_medium_square: "◻️",
  black_medium_small_square: "◾",
  white_medium_small_square: "◽",
  black_small_square: "▪️",
  white_small_square: "▫️",
  small_red_triangle: "🔺",
  black_square_button: "🔲",
  white_square_button: "🔳",
  black_circle: "⚫",
  white_circle: "⚪",
  red_circle: "🔴",
  large_blue_circle: "🔵",
  small_red_triangle_down: "🔻",
  white_large_square: "⬜",
  black_large_square: "⬛",
  large_orange_diamond: "🔶",
  large_blue_diamond: "🔷",
  small_orange_diamond: "🔸",
  small_blue_diamond: "🔹",
  flag_ac: "🇦🇨",
  flag_ad: "🇦🇩",
  flag_ae: "🇦🇪",
  flag_af: "🇦🇫",
  flag_ag: "🇦🇬",
  flag_ai: "🇦🇮",
  flag_al: "🇦🇱",
  flag_am: "🇦🇲",
  flag_ao: "🇦🇴",
  flag_aq: "🇦🇶",
  flag_ar: "🇦🇷",
  flag_as: "🇦🇸",
  flag_at: "🇦🇹",
  flag_au: "🇦🇺",
  flag_aw: "🇦🇼",
  flag_ax: "🇦🇽",
  flag_az: "🇦🇿",
  flag_ba: "🇧🇦",
  flag_bb: "🇧🇧",
  flag_bd: "🇧🇩",
  flag_be: "🇧🇪",
  flag_bf: "🇧🇫",
  flag_bg: "🇧🇬",
  flag_bh: "🇧🇭",
  flag_bi: "🇧🇮",
  flag_bj: "🇧🇯",
  flag_bl: "🇧🇱",
  flag_bm: "🇧🇲",
  flag_bn: "🇧🇳",
  flag_bo: "🇧🇴",
  flag_bq: "🇧🇶",
  flag_br: "🇧🇷",
  flag_bs: "🇧🇸",
  flag_bt: "🇧🇹",
  flag_bv: "🇧🇻",
  flag_bw: "🇧🇼",
  flag_by: "🇧🇾",
  flag_bz: "🇧🇿",
  flag_ca: "🇨🇦",
  flag_cc: "🇨🇨",
  flag_cd: "🇨🇩",
  flag_cf: "🇨🇫",
  flag_cg: "🇨🇬",
  flag_ch: "🇨🇭",
  flag_ci: "🇨🇮",
  flag_ck: "🇨🇰",
  flag_cl: "🇨🇱",
  flag_cm: "🇨🇲",
  flag_cn: "🇨🇳",
  flag_co: "🇨🇴",
  flag_cp: "🇨🇵",
  flag_cr: "🇨🇷",
  flag_cu: "🇨🇺",
  flag_cv: "🇨🇻",
  flag_cw: "🇨🇼",
  flag_cx: "🇨🇽",
  flag_cy: "🇨🇾",
  flag_cz: "🇨🇿",
  flag_de: "🇩🇪",
  flag_dg: "🇩🇬",
  flag_dj: "🇩🇯",
  flag_dk: "🇩🇰",
  flag_dm: "🇩🇲",
  flag_do: "🇩🇴",
  flag_dz: "🇩🇿",
  flag_ea: "🇪🇦",
  flag_ec: "🇪🇨",
  flag_ee: "🇪🇪",
  flag_eg: "🇪🇬",
  flag_eh: "🇪🇭",
  flag_er: "🇪🇷",
  flag_es: "🇪🇸",
  flag_et: "🇪🇹",
  flag_eu: "🇪🇺",
  flag_fi: "🇫🇮",
  flag_fj: "🇫🇯",
  flag_fk: "🇫🇰",
  flag_fm: "🇫🇲",
  flag_fo: "🇫🇴",
  flag_fr: "🇫🇷",
  flag_ga: "🇬🇦",
  flag_gb: "🇬🇧",
  flag_gd: "🇬🇩",
  flag_ge: "🇬🇪",
  flag_gf: "🇬🇫",
  flag_gg: "🇬🇬",
  flag_gh: "🇬🇭",
  flag_gi: "🇬🇮",
  flag_gl: "🇬🇱",
  flag_gm: "🇬🇲",
  flag_gn: "🇬🇳",
  flag_gp: "🇬🇵",
  flag_gq: "🇬🇶",
  flag_gr: "🇬🇷",
  flag_gs: "🇬🇸",
  flag_gt: "🇬🇹",
  flag_gu: "🇬🇺",
  flag_gw: "🇬🇼",
  flag_gy: "🇬🇾",
  flag_hk: "🇭🇰",
  flag_hm: "🇭🇲",
  flag_hn: "🇭🇳",
  flag_hr: "🇭🇷",
  flag_ht: "🇭🇹",
  flag_hu: "🇭🇺",
  flag_ic: "🇮🇨",
  flag_id: "🇮🇩",
  flag_ie: "🇮🇪",
  flag_il: "🇮🇱",
  flag_im: "🇮🇲",
  flag_in: "🇮🇳",
  flag_io: "🇮🇴",
  flag_iq: "🇮🇶",
  flag_ir: "🇮🇷",
  flag_is: "🇮🇸",
  flag_it: "🇮🇹",
  flag_je: "🇯🇪",
  flag_jm: "🇯🇲",
  flag_jo: "🇯🇴",
  flag_jp: "🇯🇵",
  flag_ke: "🇰🇪",
  flag_kg: "🇰🇬",
  flag_kh: "🇰🇭",
  flag_ki: "🇰🇮",
  flag_km: "🇰🇲",
  flag_kn: "🇰🇳",
  flag_kp: "🇰🇵",
  flag_kr: "🇰🇷",
  flag_kw: "🇰🇼",
  flag_ky: "🇰🇾",
  flag_kz: "🇰🇿",
  flag_la: "🇱🇦",
  flag_lb: "🇱🇧",
  flag_lc: "🇱🇨",
  flag_li: "🇱🇮",
  flag_lk: "🇱🇰",
  flag_lr: "🇱🇷",
  flag_ls: "🇱🇸",
  flag_lt: "🇱🇹",
  flag_lu: "🇱🇺",
  flag_lv: "🇱🇻",
  flag_ly: "🇱🇾",
  flag_ma: "🇲🇦",
  flag_mc: "🇲🇨",
  flag_md: "🇲🇩",
  flag_me: "🇲🇪",
  flag_mf: "🇲🇫",
  flag_mg: "🇲🇬",
  flag_mh: "🇲🇭",
  flag_mk: "🇲🇰",
  flag_ml: "🇲🇱",
  flag_mm: "🇲🇲",
  flag_mn: "🇲🇳",
  flag_mo: "🇲🇴",
  flag_mp: "🇲🇵",
  flag_mq: "🇲🇶",
  flag_mr: "🇲🇷",
  flag_ms: "🇲🇸",
  flag_mt: "🇲🇹",
  flag_mu: "🇲🇺",
  flag_mv: "🇲🇻",
  flag_mw: "🇲🇼",
  flag_mx: "🇲🇽",
  flag_my: "🇲🇾",
  flag_mz: "🇲🇿",
  flag_na: "🇳🇦",
  flag_nc: "🇳🇨",
  flag_ne: "🇳🇪",
  flag_nf: "🇳🇫",
  flag_ng: "🇳🇬",
  flag_ni: "🇳🇮",
  flag_nl: "🇳🇱",
  flag_no: "🇳🇴",
  flag_np: "🇳🇵",
  flag_nr: "🇳🇷",
  flag_nu: "🇳🇺",
  flag_nz: "🇳🇿",
  flag_om: "🇴🇲",
  flag_pa: "🇵🇦",
  flag_pe: "🇵🇪",
  flag_pf: "🇵🇫",
  flag_pg: "🇵🇬",
  flag_ph: "🇵🇭",
  flag_pk: "🇵🇰",
  flag_pl: "🇵🇱",
  flag_pm: "🇵🇲",
  flag_pn: "🇵🇳",
  flag_pr: "🇵🇷",
  flag_ps: "🇵🇸",
  flag_pt: "🇵🇹",
  flag_pw: "🇵🇼",
  flag_py: "🇵🇾",
  flag_qa: "🇶🇦",
  flag_re: "🇷🇪",
  flag_ro: "🇷🇴",
  flag_rs: "🇷🇸",
  flag_ru: "🇷🇺",
  flag_rw: "🇷🇼",
  flag_sa: "🇸🇦",
  flag_sb: "🇸🇧",
  flag_sc: "🇸🇨",
  flag_sd: "🇸🇩",
  flag_se: "🇸🇪",
  flag_sg: "🇸🇬",
  flag_sh: "🇸🇭",
  flag_si: "🇸🇮",
  flag_sj: "🇸🇯",
  flag_sk: "🇸🇰",
  flag_sl: "🇸🇱",
  flag_sm: "🇸🇲",
  flag_sn: "🇸🇳",
  flag_so: "🇸🇴",
  flag_sr: "🇸🇷",
  flag_ss: "🇸🇸",
  flag_st: "🇸🇹",
  flag_sv: "🇸🇻",
  flag_sx: "🇸🇽",
  flag_sy: "🇸🇾",
  flag_sz: "🇸🇿",
  flag_ta: "🇹🇦",
  flag_tc: "🇹🇨",
  flag_td: "🇹🇩",
  flag_tf: "🇹🇫",
  flag_tg: "🇹🇬",
  flag_th: "🇹🇭",
  flag_tj: "🇹🇯",
  flag_tk: "🇹🇰",
  flag_tl: "🇹🇱",
  flag_tm: "🇹🇲",
  flag_tn: "🇹🇳",
  flag_to: "🇹🇴",
  flag_tr: "🇹🇷",
  flag_tt: "🇹🇹",
  flag_tv: "🇹🇻",
  flag_tw: "🇹🇼",
  flag_tz: "🇹🇿",
  flag_ua: "🇺🇦",
  flag_ug: "🇺🇬",
  flag_um: "🇺🇲",
  flag_un: "🇺🇳",
  flag_us: "🇺🇸",
  flag_uy: "🇺🇾",
  flag_uz: "🇺🇿",
  flag_va: "🇻🇦",
  flag_vc: "🇻🇨",
  flag_ve: "🇻🇪",
  flag_vg: "🇻🇬",
  flag_vi: "🇻🇮",
  flag_vn: "🇻🇳",
  flag_vu: "🇻🇺",
  flag_wf: "🇼🇫",
  flag_ws: "🇼🇸",
  flag_xk: "🇽🇰",
  flag_ye: "🇾🇪",
  flag_yt: "🇾🇹",
  flag_za: "🇿🇦",
  flag_zm: "🇿🇲",
  flag_zw: "🇿🇼"
};



// WEBPACK FOOTER //
// ./src/component/Markdown/aliases.js